import { render, staticRenderFns } from "./DatabaseConfig.vue?vue&type=template&id=5fe7380d&"
import script from "./DatabaseConfig.vue?vue&type=script&lang=js&"
export * from "./DatabaseConfig.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports